import Swiper, { A11y, Keyboard, Navigation } from 'swiper';

import '../../sass/blocks/news.scss';

const noMotionPreference = window.matchMedia('(prefers-reduced-motion: no-preference)');

(() => {
    const $news = document.querySelectorAll('.news');

    if (!$news) return;

    $news.forEach($news => {
        const $categories = $news.querySelectorAll('.news__category');

        const initCarousels = () => {
            if (!$categories) return;

            $categories.forEach($category => {
                const $carousel = $category.querySelector('.news__category-carousel');
                const $carouselSlides = $category.querySelectorAll('.news__category-carousel-slide');
                const $carouselNext = $category.querySelector('.news__category-navigation--next');
                const $carouselPrev = $category.querySelector('.news__category-navigation--prev');

                if (!$carousel) return;

                const carousel = new Swiper($carousel, {
                    modules: [ A11y, Keyboard, Navigation ],
                    slidesPerView: 'auto',
                    keyboard: {
                        enabled: true,
                        onlyInViewport: true
                    },
                    speed: noMotionPreference.matches ? 300 : 0
                });

                if (carousel) {
                    carousel.on('slideChange', () => {
                        $carouselPrev.classList.remove('news__category-navigation--hide');
                        $carouselPrev.classList.add('news__category-navigation--navigated');
                    });
                }

                const navigationButtonsPosition = () => {
                    if (!$carouselNext || !$carouselPrev || !$carouselSlides.length) return;

                    const $image = $carouselSlides[0].querySelector('.news-card-keyline__image');
                    const $details = $carouselSlides[0].querySelector('.news-card-block__details');

                    let buttonTopPosition = '50%';

                    if ($image) {
                        buttonTopPosition = `${$image.clientHeight / 2}px`;
                    }

                    if ($details) {
                        buttonTopPosition = `${$details.clientHeight / 2}px`;
                    }

                    $carouselNext.style.top = buttonTopPosition;
                    $carouselPrev.style.top = buttonTopPosition;
                };

                const toggleNavButtons = () => {
                    if (!$carouselSlides?.length || $carouselSlides?.length <= 1 || (window.innerWidth >= 1200 && $carouselSlides?.length <= 2)) {
                        if ($carouselNext) $carouselNext.classList.add('news__category-navigation--hide');
                        if ($carouselPrev && $carouselPrev.classList.contains('news__category-navigation--navigated')) $carouselPrev.classList.add('news__category-navigation--hide');
                    } else {
                        if ($carouselNext) $carouselNext.classList.remove('news__category-navigation--hide');
                        if ($carouselPrev && $carouselPrev.classList.contains('news__category-navigation--navigated')) $carouselPrev.classList.remove('news__category-navigation--hide');
                    }
                };

                if ($carouselNext && $carouselSlides?.length && carousel) {
                    $carouselNext.addEventListener('click', () => {
                        const endIndex = window.innerWidth >= 1200 ? carousel.activeIndex + 2 : carousel.activeIndex + 1;
    
                        if (endIndex < $carouselSlides.length) {
                            carousel.slideNext();
                        } else {
                            carousel.slideTo(0);
                        }
                    });
                }

                if ($carouselPrev && $carouselSlides?.length && carousel) {
                    $carouselPrev.addEventListener('click', () => {
                        if (carousel.activeIndex === 0) {
                            carousel.slideTo($carouselSlides.length - 1);
                        } else {
                            carousel.slidePrev();
                        }
                    });
                }

                window.addEventListener('resize', () => {
                    toggleNavButtons();
                    navigationButtonsPosition();
                });

                window.addEventListener('load', () => {
                    navigationButtonsPosition();
                });

                toggleNavButtons();
                navigationButtonsPosition();
            });
        };

        initCarousels();
    });
})();
